import styled, { css } from 'styled-components';
import { PlayLinkContainer } from '../../../Link';
import { regularWhite, fontWeightBold } from '../../../../ui-components/design-tokens';
import { regularOutline } from '../../../../ui-components/typography/helpers';
import { device } from '../../../../ui-components/breakpoints';

export const ListItem = styled.li`
    display: inline-block;
    margin-top: -2px;
    margin-left: 0;
    overflow: hidden;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    @media ${device.GteSmall} {
        display: block;
        float: left;
    }

    ${(props) =>
        props.type === 'search' &&
        css`
            @media ${device.GteSmall} {
                display: none;
            }
        `}
`;

export const Link = styled(PlayLinkContainer)`
    color: ${regularWhite};
    text-decoration: none;
    display: block;
    padding: 10px 8px;

    &:focus {
        ${regularOutline('-2px')}
        text-decoration: underline;
    }

    &:hover {
        text-decoration: underline;
    }

    &:hover,
    &:active,
    &:visited {
        color: ${regularWhite};
    }

    &.play_is-active {
        span {
            font-weight: ${fontWeightBold};
        }
    }

    @media ${device.GteMedium} {
        padding: 10px 15px;
    }
`;
